import { SensitiveData, TextAlignment } from '@philips-internal/oswald-ui-constants';
import { bool, expression, formatters, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { TextFontFamily, TextFontSize, TextSignalColor, TextSignalShade, TextType } from './text-constants.js';
const TextProperties = {
    alignment: {
        defaultValue: TextAlignment.INITIAL,
        type: oneOf(enumValues(TextAlignment)).group('modifiers'),
    },
    bold: {
        type: bool.group('modifiers'),
    },
    className: {
        type: string,
    },
    disableTranslation: {
        type: bool,
    },
    ellipsis: {
        type: bool.group('modifiers'),
    },
    family: {
        defaultValue: TextFontFamily.BOOK,
        type: oneOf(enumValues(TextFontFamily)).group('modifiers'),
    },
    formatters: {
        type: formatters,
    },
    sensitiveData: {
        defaultValue: SensitiveData.NONE,
        type: oneOf(enumValues(SensitiveData)),
    },
    signalColor: {
        defaultValue: TextSignalColor.SIGNAL_BLUE,
        type: oneOf(enumValues(TextSignalColor)).group('modifiers'),
    },
    signalShade: {
        defaultValue: TextSignalShade.SHADE_45,
        type: oneOf(enumValues(TextSignalShade)).group('modifiers'),
    },
    size: {
        defaultValue: TextFontSize.DEFAULT,
        type: oneOf(enumValues(TextFontSize)).group('modifiers'),
    },
    strikethrough: {
        type: bool.group('modifiers'),
    },
    type: {
        defaultValue: TextType.PRIMARY,
        type: oneOf(enumValues(TextType)).group('modifiers'),
    },
    uppercase: {
        type: bool.group('modifiers'),
    },
    value: {
        type: expression,
    },
};
export { TextProperties, };
//# sourceMappingURL=text-types.js.map